import {
  measureActivitySelectionListRenderPerformance,
  measureFirstItineraryRenderPerformance,
  measureHotelSelectionListRenderPerformance,
} from '@libs/utils';

import { getMetrics } from '../metrics/metrics';

import { logStatsigEvent } from './statsigConfiguration';

const enum StatsigPerformanceEventType {
  // Initialization
  PerformancePageLoaded = 'performance_page_loaded',
  PerformanceAppInitiated = 'performance_app_initiated',
  // Itinerary
  PerformanceTripOverviewPageRendered = 'trip_overview_page_rendered',
  PerformanceItineraryRequested = 'performance_itinerary_requested',
  PerformanceItineraryReceived = 'performance_itinerary_received',
  PerformanceItineraryRendered = 'performance_itinerary_rendered',
  PerformanceItineraryTotalTimeToRender = 'performance_itinerary_total_time_to_render',
  // Hotel List
  PerformanceHotelListRequested = 'performance_hotel_list_requested',
  PerformanceHotelListReceived = 'performance_hotel_list_received',
  PerformanceHotelListRendered = 'performance_hotel_list_rendered',
  PerformanceHotelListTotalTimeToRender = 'performance_hotel_list_total_time_to_render',
  // Activity List
  PerformanceActivityListRequested = 'performance_activity_list_requested',
  PerformanceActivityListReceived = 'performance_activity_list_received',
  PerformanceActivityListRendered = 'performance_activity_list_rendered',
  PerformanceActivityListTotalTimeToRender = 'performance_activity_list_total_time_to_render',
}

const metrics = getMetrics();
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const HISTOGRAM_THRESHOLDS = [50, 100, 200, 400, 800, 1600, 3200, 6400, 12800];

export function trackPerformancePageLoaded(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformancePageLoaded,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceAppInitiated(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceAppInitiated,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceTripOverviewPageRendered(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceTripOverviewPageRendered,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceItineraryRequested(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceItineraryRequested,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceItineraryReceived(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceItineraryReceived,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceItineraryRendered(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceItineraryRendered,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceItineraryTotalTimeToRender(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceItineraryTotalTimeToRender,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceHotelListRequested(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceHotelListRequested,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceHotelListReceived(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceHotelListReceived,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceHotelListRendered(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceHotelListRendered,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceHotelListTotalTimeToRender(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceHotelListTotalTimeToRender,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceActivityListRequested(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceActivityListRequested,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceActivityListReceived(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceActivityListReceived,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceActivityListRendered(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceActivityListRendered,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceActivityListTotalTimeToRender(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    StatsigPerformanceEventType.PerformanceActivityListTotalTimeToRender,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

const enum DeserializeFlowEventType {
  DeserializeHotelWithOldIngredientPrefix = 'deserialize_hotel_with_old_ingredient_prefix',
  DeserializeHotelWithoutHotelFiltersPrefix = 'deserialize_hotel_without_hotel_filters_prefix',
  DeserializeHotelWithoutSuggestionOrderPrefix = 'deserialize_hotel_without_suggestion_order_prefix',
  DeserializeHotelWithOldRoomPrefix = 'deserialize_hotel_with_old_room_prefix',
  DeserializeHotelWithoutBoardBasisPrefix = 'deserialize_hotel_without_board_basis_prefix',
  DeserializeHotelWithoutRoomTypeId = 'deserialize_hotel_without_room_type_id',
  DeserializeStayWithoutSelectionPrefix = 'deserialize_stay_without_selection_prefix',
  DeserializeTransportWithoutSuggestionOrderPrefix = 'deserialize_transport_without_suggestion_order_prefix',
  DeserializeActivityWithSupplierToken = 'deserialize_activity_with_supplier_token',
}

interface UrlMetadata extends Record<string, string> {
  url: string;
  referrer: string;
}

export function getUrlMetadata(): UrlMetadata {
  return {
    url: window.location.href,
    referrer: document.referrer,
  };
}

export function trackDeserializeHotelWithOldIngredientPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithOldIngredientPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutHotelFiltersPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutHotelFiltersPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutSuggestionOrderPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutSuggestionOrderPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithOldRoomPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithOldRoomPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutBoardBasisPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutBoardBasisPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutRoomTypeId(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutRoomTypeId,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeStayWithoutSelectionPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeStayWithoutSelectionPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeTransportWithoutSuggestionOrderPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeTransportWithoutSuggestionOrderPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeActivityWithSupplierToken(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeActivityWithSupplierToken,
    undefined,
    getUrlMetadata()
  );
}

export function trackFallbackStaticInfoReceived(
  constraintSelection: string
): void {
  logStatsigEvent(
    'telemetry_fallback_static_info_received',
    constraintSelection
  );
}

export function trackPerformance(): void {
  measureFirstItineraryRenderPerformance().then(
    ({
      timeToTripOverviewPageRendered,
      timeToFirstItineraryAvailabilityRequestMs,
      timeToFirstItineraryAvailabilityReceivedMs,
      timeToFirstItineraryRenderedMs,
      totalTimeRequiredToRenderFirstItinerary,
    }) => {
      trackPerformanceTripOverviewPageRendered(timeToTripOverviewPageRendered);
      trackPerformanceItineraryRequested(
        timeToFirstItineraryAvailabilityRequestMs
      );
      trackPerformanceItineraryReceived(
        timeToFirstItineraryAvailabilityReceivedMs
      );
      trackPerformanceItineraryRendered(timeToFirstItineraryRenderedMs);
      trackPerformanceItineraryTotalTimeToRender(
        totalTimeRequiredToRenderFirstItinerary
      );
    }
  );

  measureHotelSelectionListRenderPerformance().then(
    ({
      timeToHotelSelectionViewAvailabilityRequestMs,
      timeToHotelSelectionViewAvailabilityReceivedMs,
      timeToHotelSelectionListRenderedMs,
      totalTimeRequiredToRenderHotelSelectionList,
    }) => {
      trackPerformanceHotelListRequested(
        timeToHotelSelectionViewAvailabilityRequestMs
      );
      trackPerformanceHotelListReceived(
        timeToHotelSelectionViewAvailabilityReceivedMs
      );
      trackPerformanceHotelListRendered(timeToHotelSelectionListRenderedMs);
      trackPerformanceHotelListTotalTimeToRender(
        totalTimeRequiredToRenderHotelSelectionList
      );
    }
  );

  measureActivitySelectionListRenderPerformance().then(
    ({
      timeToActivitySelectionViewAvailabilityRequestMs,
      timeToActivitySelectionViewAvailabilityReceivedMs,
      timeToActivitySelectionListRenderedMs,
      totalTimeRequiredToRenderActivitySelectionList,
    }) => {
      trackPerformanceActivityListRequested(
        timeToActivitySelectionViewAvailabilityRequestMs
      );
      trackPerformanceActivityListReceived(
        timeToActivitySelectionViewAvailabilityReceivedMs
      );
      trackPerformanceActivityListRendered(
        timeToActivitySelectionListRenderedMs
      );
      trackPerformanceActivityListTotalTimeToRender(
        totalTimeRequiredToRenderActivitySelectionList
      );
    }
  );
}
